<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="mr-16" [routerLink]="'/companies'">
                    <mat-icon>arrow_back</mat-icon>
            </button>
            <h2 class="m-0">{{'PERFILES.EMPRESA.TITUHEAD' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [ngClass]="">



            <!-- CONTENT -->
            <div class="content p-24">

                <div class="h1">
                    {{'CONSULTATABLA.LABEL1' | translate}}
                </div>

                <p class="pt-16 pb-32">
                    <!-- {{'CONSULTATABLA.DESCDETAIL' | translate}} -->
                </p>

                <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

                    <!-- REACTIVE FORM EXAMPLE -->
                    <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto">

                        <div class="h2 mb-24">{{'CONSULTATABLA.DETAIL' | translate}}</div>

                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                            <mat-form-field appearance="outline" fxFlex="100">
                                <mat-label>{{'CONSULTATABLA.EMPRESA' | translate}}</mat-label>
                                <input matInput value="{{nombreEmpresa}}" disabled>
                            </mat-form-field>

                        </div>

                        <div *ngIf="!paqueteActual" class="" fxLayout="row" fxLayoutAlign="space-between center">
                          <div fxLayout="column" fxLayoutAlign="center center" fxFlex="grow">
                            <h3>{{'PAQUETES.PREVIO.INFO' | translate}}</h3>
                          </div>
                          <mat-divider [vertical]="true"></mat-divider>
                          <div class="" fxLayout="column" fxLayoutAlign="start stretch">
                            <!-- <p>Acciones</p> -->
                            <button mat-raised-button color="accent" class="mb-20" (click)="agregaPaquete()">
                              <mat-icon class="mr-20">add_circle</mat-icon>
                              {{'PAQUETES.PREVIO.BOTONES.ADD' | translate}}
                            </button>
                            <button mat-raised-button color="accent">
                              <mat-icon class="mr-20">calendar_today</mat-icon>
                              {{'PAQUETES.PREVIO.BOTONES.SEE' | translate}}
                            </button>
                          </div>
                        </div>

                        <!--- paquete vigente --->
                        <div *ngIf="paqueteActual" class="" fxLayout="column" fxLayoutAlign="start stretch">

                          <div class="" fxLayout="column" fxLayoutAlign="start center">

                            <h3>{{'PAQUETES.INFOPAQ.TITULO' | translate}}</h3><br>

                            <div class="mat-elevation-z4 p-20 roundEdg" fxLayout="row" fxLayoutAlign="space-between center">
                              <button mat-mini-fab disabled
                                [ngClass]="{
                                  'icoSil':paqueteActual.nombrePaquete == 'plata',
                                  'icoOro':paqueteActual.nombrePaquete == 'oro',
                                  'icoPla':paqueteActual.nombrePaquete == 'platino'
                                }">
                                <mat-icon>star</mat-icon>
                              </button>
                              <h2 class="ml-20 mt-0 mb-0">{{'PAQUETES.NOMBRES.'+paqueteActual.tipo | translate}}</h2>
                            </div>
                            <em class="mt-20"><b>{{'PAQUETES.INFOPAQ.APLICA' | translate}} {{paqueteActual.fecha}}</b></em>
                          </div>

                          <mat-divider class="m-20"></mat-divider>

                          <div class="" fxLayout="column" fxLayoutAlign="start stretch">
                            <em class="mt-0 mb-10">{{'PAQUETES.INFOPAQ.AVANCE' | translate}}</em>
                            <mat-progress-bar mode="determinate" value="{{porcentajeAvance}}"></mat-progress-bar>
                            <h4 class="mt-0 mb-10 midText">{{porcentajeAvance}}%</h4>
                          </div>

                          <div *ngIf="!restoProds" fxLayout="row" fxLayoutAlign="space-around" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">

                            <div class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                              <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="agregaProducto(1,'producto','certificar')">
                                <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                  <ng-container *ngIf="!OK_certificar; else iconoCompleto_1">
                                    <button mat-mini-fab disabled>
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.1' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.NOTOK_1' | translate}}</em>
                                  </ng-container>
                                  <ng-template #iconoCompleto_1>
                                    <button mat-mini-fab disabled class="prodComp">
                                      <mat-icon>check</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.1' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.OK_1' | translate}}</em>
                                  </ng-template>
                                </div>
                              </button>
                            </div>

                            <div *ngIf="paqueteActual.tipo == 3" class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                              <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="muestraRestoProds()">
                                <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                  <button mat-mini-fab disabled>
                                    <mat-icon>more_horiz</mat-icon>
                                  </button>
                                  <h3 class="mb-0 ws">{{'PAQUETES.INFOPAQ.STATUS.ADICIONAL' | translate}}</h3>
                                  <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.ADINFO' | translate}}</em>
                                </div>
                              </button>
                            </div>

                            <div class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                              <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="agregaProducto(2,'categoria','cultureaudit')">
                                <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                  <ng-container *ngIf="OK_ca != 2; else iconoCompleto_3">
                                    <button mat-mini-fab disabled>
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.8' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.NOTOK_1' | translate}}</em>
                                  </ng-container>
                                  <ng-template #iconoCompleto_3>
                                    <button mat-mini-fab disabled class="prodComp">
                                      <mat-icon>check</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.8' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.OK_1' | translate}}</em>
                                  </ng-template>
                                </div>
                              </button>
                            </div>

                            <div class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                              <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="agregaProducto(3,'categoria','resultados')">
                                <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                  <ng-container *ngIf="!OK_resultados; else iconoCompleto_4">
                                    <button mat-mini-fab disabled>
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.17' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.NOTOK_1' | translate}}</em>
                                  </ng-container>
                                  <ng-template #iconoCompleto_4>
                                    <button mat-mini-fab disabled class="prodComp">
                                      <mat-icon>check</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.17' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.OK_1' | translate}}</em>
                                  </ng-template>
                                </div>
                              </button>
                            </div>

                          </div>

                          <!--- resto de productos -->
                          <div *ngIf="restoProds" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                            <div class="mb-20" fxLayout="row" fxLayoutAlign="start">
                              <button mat-raised-button color="accent" (click)="muestraRestoProds()">
                                <mat-icon class="mr-20">arrow_back</mat-icon>
                                {{'PAQUETES.INFOPAQ.BOTONES.BACK' | translate}}
                              </button>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-around">

                              <div class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                                <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="agregaProducto(4,'categoria','medir')">
                                  <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                    <button mat-mini-fab disabled>
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.2' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.NOTOK_1' | translate}}</em>
                                  </div>
                                </button>
                              </div>

                              <div class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                                <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="agregaProducto(5,'categoria','pulse')">
                                  <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                    <button mat-mini-fab disabled>
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.4' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.NOTOK_1' | translate}}</em>
                                  </div>
                                </button>
                              </div>

                              <div class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                                <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="agregaProducto(6,'categoria','focus')">
                                  <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                    <button mat-mini-fab disabled>
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.6' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.NOTOK_1' | translate}}</em>
                                  </div>
                                </button>
                              </div>

                              <div class="" fxFlex="20" fxLayout="column" fxLayoutAlign="start stretch">
                                <button mat-raised-button fxFlex="100" fxLayout="column" fxLayoutAlign="start stretch" matTooltip="{{'PAQUETES.TOOLTIP.CONFIG' | translate}}" matTooltipPosition="above" (click)="agregaProducto(7,'categoria','nom35')">
                                  <div class="p-20" fxFlex="100" fxLayout="column" fxLayoutAlign="space-between center">
                                    <button mat-mini-fab disabled>
                                      <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <h3 class="mb-0 ws">{{'CONSULTATABLA.PRODUCTOS.3' | translate}}</h3>
                                    <em class="mt-20">{{'PAQUETES.INFOPAQ.STATUS.TITULO' | translate}} {{'PAQUETES.INFOPAQ.STATUS.NOTOK_1' | translate}}</em>
                                  </div>
                                </button>
                              </div>

                            </div>
                          </div>

                        </div>

                    </div>
                    <!-- / REACTIVE FORM EXAMPLE -->

                    <!-- <div class="mat-card form-errors-model p-24 mat-elevation-z4">
                        <div class="h2 mb-24">{{'CONSULTATABLA.LABELCONTRATADOS' | translate}}</div>
                    </div> -->

                </div>


            </div>
            <!-- / CONTENT -->

        </div>
